/* tslint:disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type FooterBottomRow_viewer = {
    readonly user?: {
        readonly " $fragmentRefs": FragmentRefs<"CurrencySelector_user">;
    } | null;
    readonly " $fragmentRefs": FragmentRefs<"CurrencySelector_viewer">;
    readonly " $refType": "FooterBottomRow_viewer";
};
export type FooterBottomRow_viewer$data = FooterBottomRow_viewer;
export type FooterBottomRow_viewer$key = {
    readonly " $data"?: FooterBottomRow_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"FooterBottomRow_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "FooterBottomRow_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String!"
    },
    {
      "kind": "RootArgument",
      "name": "hasUserId",
      "type": "Boolean"
    }
  ],
  "selections": [
    {
      "kind": "Condition",
      "passingValue": true,
      "condition": "hasUserId",
      "selections": [
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "user",
          "storageKey": null,
          "args": [
            {
              "kind": "Variable",
              "name": "userId",
              "variableName": "userId"
            }
          ],
          "concreteType": "User",
          "plural": false,
          "selections": [
            {
              "kind": "FragmentSpread",
              "name": "CurrencySelector_user",
              "args": null
            }
          ]
        }
      ]
    },
    {
      "kind": "FragmentSpread",
      "name": "CurrencySelector_viewer",
      "args": null
    }
  ]
};
(node as any).hash = 'e2b922f152c8b16822665165dff91495';
export default node;
